import csuBanner from '../assets/het-geluid-2025-nl/csu_banner.gif'
import headerImage2024BE from '../assets/het-geluid-2024-be/header_image.jpg'

/*
    type: welk type aanmeldmoment is het? sockets / api
    theme: welk merk is het aanmeldmoment voor? qmusic / joe
    copy: {
        title: titel van het aanmeldmoment
        description: beschrijving van het aanmeldmoment
        button: tekst op de aanmeldknop
        success: {
            title: titel van de succesmelding
            description: beschrijving van de succesmelding
            button: tekst op de succesknop
        }
    }
*/

const configs = {
  het_geluid_nl: {
    stationId: 'qmusic_nl',
    theme: 'qmusic',
    type: 'api',
    title: 'Het Geluid NL',
    optIn: true,
    headerVideoId: 766893,
    campaignPageLink: 'https://qmusic.nl/embed/acties/het-geluid-2024',
    sponsorImage: csuBanner,
    sponsorLink: 'https://www.csu.nl/qmusic-het-geluid/?utm_source=Actiepagina+Q&utm_id=Q+2024',
    translation: {
      campaign: {
        name: 'Het Geluid',
        description: `Weet jij wat Het Geluid is? Speel hier mee! Meld je hieronder elk uur aan en maak kans om mee te raden.`,
        extraInfo: `Je meldt jezelf telkens voor één dag aan. Meld je dus iedere dag opnieuw aan! Als jij aangemeld bent, kan je zomaar teruggebeld worden om mee te spelen met Het Geluid.`,
      },
      campaignPage: {
        linkCopy: 'Lees meer over Het Geluid',
      },
      campaignEndPage: {
        linkCopy: 'Bekijk hier de video',
      },
      wrongAnswers: {
        title: 'Foute antwoorden',
        description: 'Deze antwoorden zijn al gegeven en zijn niet Het Geluid.',
      },
      signupMoment: {
        title: 'Meld je aan voor Het Geluid',
        preview: {
          title: 'Nog even geduld',
          description: `Oeps, je kunt je even niet aanmelden.`,
        },
        notRunning: {
          title: 'Nog even geduld',
          description: `Oeps, je kunt je even niet aanmelden.`,
        },
        running: {
          btn: 'Meld mij aan',
        },
        success: {
          title: 'Je bent aangemeld!',
          description:
            '<strong>Houd je telefoon in de gaten</strong>, wie weet pikt de computer jou eruit om mee te spelen.',
          warning: '',
        },
      },
      soundListener: {
        title: 'Luister naar Het Geluid',
        description: 'Spits je oren en raad wat het is.',
      },
      tooMuchListens: {
        title: 'Je hebt al geluisterd naar Het Geluid',
        description: `Je kan tot de start van Het Geluid maar 1 keer luisteren naar het geluid.`,
        button: 'Oke',
      },
    },
  },
  het_geluid_be: {
    stationId: 'qmusic_be',
    theme: 'qmusic',
    type: 'api',
    title: 'Het Geluid BE',
    optIn: true,
    headerImage: headerImage2024BE,
    campaignPageLink: 'https://qmusic.be/embed/kom-hier-alles-te-weten-over-het-geluid-2024',
    campaignEndedLink: 'https://qmusic.be/embed/check-hier-wat-het-was',
    sound: {
      url: 'https://cdn-radio.dpgmedia.net/store/media/het_geluid_2024_1.mp3',
      code: 'het-geluid-2024-1',
      loginRequired: new Date() < new Date('2024-09-09T06:00:00.000+0200'),
      maxPlays: new Date() < new Date('2024-09-09T06:00:00.000+0200') ? 1 : null,
    },
    campaignActive: 6 <= new Date().getHours() && new Date().getHours() < 19 && new Date().getDay() < 6,
    translation: {
      campaign: {
        name: 'Het Geluid',
        description: `Het Geluid is geraden! Check hieronder wat Het Geluid is!`,
        extraInfo: '',
      },
      campaignPage: {
        linkCopy: 'Lees meer over Het Geluid',
      },
      campaignEndPage: {
        linkCopy: 'Bekijk hier de video',
      },
      wrongAnswers: {
        title: 'Foute antwoorden',
        description: 'Deze antwoorden zijn al gegeven en zijn niet Het Geluid.',
      },
      signupMoment: {
        title: 'Weet jij al wat het is?',
        preview: {
          title: 'Nog even geduld',
          description: `Meespelen met Het Geluid kan enkel van maandag tot en met vrijdag van 6u tot 19u. Laat je brein dus nog even rusten.`,
        },
        notRunning: {
          title: 'Nog even geduld',
          description: `Meespelen met Het Geluid kan enkel van maandag tot en met vrijdag van 6u tot 19u. Laat je brein dus nog even rusten.`,
        },
        running: {
          btn: 'Meld je hier aan',
          description:
            'Meld je hieronder aan voor het komende spelmoment. Misschien pikt de computer jou eruit om mee te raden.',
        },
        success: {
          title: 'Je bent aangemeld voor het komende spelmoment!',
          description:
            '<strong>Houd je gsm in de gaten</strong>, wie weet pikt de computer jou eruit om mee te spelen.',
          warning: '',
        },
      },
      soundListener: {
        title: 'Luister naar Het Geluid',
        description: 'Spits je oren en raad wat het is.',
      },
      tooMuchListens: {
        title: 'Je hebt al geluisterd naar Het Geluid',
        description: `Je kan tot de start van Het Geluid maar 1 keer luisteren naar het geluid.`,
        button: 'Oke',
      },
    },
  },
  het_geluid_test: {
    stationId: 'test_station_qnl',
    theme: 'qmusic',
    type: 'api',
    title: 'Het Geluid BE',
    headerImage: headerImage2024BE,
    campaignPageLink: 'https://qmusic.be/embed/het-geluid-komt-terug',
    campaignEndedLink: 'https://qmusic.be/het-geluid',
    sound: {
      url: 'https://cdn-radio.dpgmedia.net/store/media/het-geluid-2024.mp3',
      code: 'het-geluid-2024',
      loginRequired: new Date() < new Date('2024-09-06T06:00:00.000Z+0200'),
      maxPlays: new Date() < new Date('2024-09-06T06:00:00.000Z+0200') ? 1 : null,
    },
    campaignActive: 6 < new Date().getHours() && new Date().getHours() < 19 && new Date().getDay() < 6,
    campaignEnded: false,
    sponsorImage: csuBanner,
    sponsorLink: 'https://www.csu.nl/qmusic-het-geluid/?utm_source=Actiepagina+Q&utm_id=Q+2024',
    optIn: true,
    translation: {
      campaign: {
        name: 'Het Geluid',
        description: `Weet jij wat Het Geluid is? Speel hier mee! Meld je hieronder elk uur aan en maak kans om mee te raden.`,
        extraInfo: `Je meldt jezelf telkens voor één dag aan. Meld je dus iedere dag opnieuw aan! Als jij aangemeld bent, kan je zomaar teruggebeld worden om mee te spelen met Het Geluid.`,
      },
      campaignPage: {
        linkCopy: 'Lees meer over Het Geluid',
      },
      campaignEndPage: {
        linkCopy: 'Bekijk hier de video',
      },
      wrongAnswers: {
        title: 'Foute antwoorden',
        description: 'Deze antwoorden zijn al gegeven en zijn niet Het Geluid.',
      },
      signupMoment: {
        title: 'Meld je aan voor Het Geluid',
        preview: {
          title: 'Nog even geduld',
          description: `Meespelen met Het Geluid kan vanaf vrijdag om 14:30 uur. Tot die tijd mag je nog even nadenken wat Het Geluid is.`,
        },
        notRunning: {
          title: 'Nog even geduld',
          description: `Meespelen met Het Geluid kan vanaf vrijdag om 14:30 uur. Tot die tijd mag je nog even nadenken wat Het Geluid is.`,
        },
        running: {
          btn: 'Meld mij aan',
        },
        success: {
          title: 'Je bent aangemeld!',
          description:
            '<strong>Houd je telefoon in de gaten</strong>, wie weet pikt de computer jou eruit om mee te spelen.',
          warning: '',
        },
      },
      soundListener: {
        title: 'Luister naar Het Geluid',
        description: 'Spits je oren en raad wat het is.',
      },
      tooMuchListens: {
        title: 'Je hebt al geluisterd naar Het Geluid',
        description: `Je kan tot de start van Het Geluid maar 1 keer luisteren naar het geluid.`,
        button: 'Oke',
      },
    },
  },
  joe_fm: {
    stationId: 'joe_fm',
    theme: 'joe',
    type: 'api',
    title: 'De Lach',
    translation: {
      wrongAnswers: {
        title: 'Foute antwoorden',
        description: 'Deze antwoorden zijn al gegeven en zijn niet De Lach.',
      },
    },
  },
}

function getCampaign(allowedCampaigns) {
  const defaultCampaign = 'het_geluid_be'

  const campaignsByDomain = [
    { pattern: /qmusic\.nl/, campaign: 'het_geluid_nl' },
    { pattern: /qmusic\.be/, campaign: 'het_geluid_be' },
    { pattern: /joe\.be/, campaign: 'joe_fm' },
  ]

  const queryParamCampaign = new URLSearchParams(window.location.search).get('campaign')
  const campaignFromDomain = campaignsByDomain.find(({ pattern }) => pattern.test(window.location.hostname))?.campaign
  const campaign = queryParamCampaign || campaignFromDomain || defaultCampaign
  return allowedCampaigns.includes(campaign) ? campaign : defaultCampaign
}

const campaign = getCampaign(Object.keys(configs))
export default configs
export const CAMPAIGN_NAME = campaign
export const CAMPAIGN_CONFIG = configs[campaign]
